const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://4nq8hv7jw6.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://o98l27fiyk.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.dev.dlpocclient.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.dlpocclient.forwoodsafety.com',
    WEBSOCKET: 'wss://9ltq2u61yc.execute-api.us-west-2.amazonaws.com/dev'
  },
};

export default config;
